<script setup>
import { defineProps, ref, defineEmits } from 'vue';
import HeaderIcon from './HeaderIcon.vue';
import MobileMenuModal from './MobileMenuModal.vue';

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    menuItems: {
        type: Array,
        required: true,
    },
    activePath: {
        type: String,
        default: '',
    },
    isMobile: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const handleClose = () => {
    emit('close');
};

const isModalOpen = ref(props.isMobile);
</script>

<template>
    <div v-if="!isMobile" class="third-level-menu">
        <div class="third-level-menu__gradient">
            <div class="header__container">
                <div class="third-level-menu__wrapper">
                    <div class="third-level-menu__group">
                        <template
                            v-for="section in menuItems"
                            :key="section.id"
                        >
                            <template v-for="block in section" :key="block.id">
                                <div
                                    v-for="item in block"
                                    :key="item.id"
                                    class="third-level-menu__nav-group"
                                >
                                    <h3
                                        v-if="item.name"
                                        class="third-level-menu__title"
                                    >
                                        {{ item.name }}
                                    </h3>

                                    <ul class="third-level-menu__list">
                                        <li
                                            class="third-level-menu__list-item"
                                            v-for="subItem in item.items"
                                            :key="subItem.id"
                                            :class="{
                                                'third-level-menu__list-item--active':
                                                    subItem?.url === activePath,
                                            }"
                                        >
                                            <a
                                                class="third-level-menu__link"
                                                :class="{
                                                    'third-level-menu__link--active':
                                                        subItem?.url ===
                                                        activePath,
                                                }"
                                                :href="subItem?.url"
                                                :target="
                                                    subItem._blank === 'Y'
                                                        ? '_blank'
                                                        : '_self'
                                                "
                                            >
                                                {{ subItem.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </template>
                    </div>

                    <button
                        class="third-level-menu__close-btn"
                        @click="handleClose"
                    >
                        <header-icon name="close-circle" />
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile -->
    <mobile-menu-modal
        v-else
        :is-open="isModalOpen"
        :title="title"
        @close="handleClose"
    >
        <div class="third-level-menu__mobile">
            <div class="third-level-menu__mobile-content">
                <template v-for="section in menuItems" :key="section.id">
                    <template v-for="block in section" :key="block.id">
                        <div
                            v-for="item in block"
                            :key="item.id"
                            class="third-level-menu__mobile-group"
                        >
                            <h3
                                v-if="item.name"
                                class="third-level-menu__mobile-title"
                            >
                                {{ item.name }}
                            </h3>

                            <ul class="third-level-menu__mobile-list">
                                <li
                                    class="third-level-menu__mobile-list-item"
                                    v-for="subItem in item.items"
                                    :key="subItem.id"
                                >
                                    <a
                                        class="third-level-menu__mobile-link"
                                        :class="{
                                            'third-level-menu__mobile-link--active':
                                                subItem?.url === activePath,
                                        }"
                                        :href="subItem?.url"
                                        :target="
                                            subItem._blank === 'Y'
                                                ? '_blank'
                                                : '_self'
                                        "
                                    >
                                        {{ subItem.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </mobile-menu-modal>
</template>
